






import Vue from "vue";
import {
  Component,
  Prop,
  Watch,
  Provide
} from "vue-property-decorator";
import { D3GlobeMap } from "@/components/d3components";

const width = 900;
const height = 900;

@Component
export default class GlobeMapComponentTmp extends Vue {
  isMounted = false;
  d3g!: D3GlobeMap;
  width = width;
  height = height;
  @Prop() rotation!: [number, number, number];
  @Prop({ type: Number }) scale!: number;
  @Provide() globeData: any = {};

  mounted() {
    this.d3g = new D3GlobeMap(this.$el, this.width, this.height, {scale: this.scale});
    this.globeData.mapContainer = this.d3g;
    this.isMounted = true;
  }

  @Watch("rotation", { deep: true })
  onRotationChange(rotation: [number, number, number]) {
    this.d3g.rotation = rotation;
  }

  getRotation() {
    return this.d3g.rotation;
  }

  rotateTo(p) {
    this.d3g.rotateTo(p);
  }


}
